import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const ListEmployee = createAsyncThunk('employee-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}employee/list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createEmployee = createAsyncThunk('employee-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}employee/store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const editEmployee = createAsyncThunk('employee-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}employee/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const viewEmployee = createAsyncThunk('employee-view', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}employee/view/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createEducation = createAsyncThunk('educations-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}employee/create/education`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const editEducation = createAsyncThunk(
  'employee-edit-education',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}employee/edit/education/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const viewEducations = createAsyncThunk('educations-view', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}employee/view/educations/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createExperience = createAsyncThunk(
  'experience-create',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}employee/create/experience`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const editExperience = createAsyncThunk('edit-experience', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}employee/edit/experience/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const viewExperiences = createAsyncThunk(
  'experiences-view',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}employee/view/experiences/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createContract = createAsyncThunk('contract-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}employee/create/contract`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const editContract = createAsyncThunk('edit-contract', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}employee/edit/contract/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const viewContracts = createAsyncThunk('contracts-view', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}employee/view/contracts/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetEmployeeList = createAsyncThunk('get-employee-list', async (__, thunkAPI) => {
  try {
    const response = await axios.get(`${api}employee/get/list`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const endContract = createAsyncThunk('contract-end', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}employee/end/contract`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const employeeContractPrint = createAsyncThunk(
  'employee-contract-print',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}employee/print-contract/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const GetEmployeeListAccount = createAsyncThunk(
  'get-employee-list-for-account',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}employee/get/employee/list/account`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createUserAccount = createAsyncThunk(
  'create-user-account',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}employee/user/account`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const printEmployeeIdCard = createAsyncThunk(
  'employee-print-card',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}employee/print-card/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getEmployeeAccountDetails = createAsyncThunk(
  'account-details',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}employee/account-details/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getEmployeeRelatedItemsClearance = createAsyncThunk(
  'related-items-clearance',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}employee/related-items-clearance/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const moveItemToStock = createAsyncThunk(
  'move-items-to_stock',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}employee/move-items-to_stock/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const positionResponse = createAsyncThunk('employee-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}employee/pos-responsibility/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PrintEmployees = createAsyncThunk('print-employees', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}employee/print-employees`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const EmployeesExcel = createAsyncThunk('employee-excel', async (params: {}) => {
  const response = await axios.get(`${api}employee/excel-employees`, {
    params,
    responseType: 'blob',
  })

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = 'Employee List.xlsx'
  document.body.appendChild(link)
  link.click()

  link.remove()
  window.URL.revokeObjectURL(url)
})

type employeeState = {
  errors: any
}

const initialState: employeeState = {
  errors: '',
}

export const employeeSlice = createSlice({
  name: 'employee',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(createEmployee.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(createEducation.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(createExperience.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(createContract.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(createUserAccount.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = employeeSlice.actions
export default employeeSlice.reducer
